import moment from 'moment'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'

const Container = styled(Clickable)`
  position: relative;
  display: flex;
  height: fit-content;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  border: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  border-radius: ${(props) => props.theme.borderRadius.S};
`

const Item = styled.div`
  padding: ${rem(8)} ${rem(16)};
  width: 100%;
  justify-self: stretch;

  &:not(:first-child) {
    border-left: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  }
`

interface BaseProps extends PropsWithChildren<{}> {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

interface DatesProps extends BaseProps {
  checkinDate?: moment.Moment
  checkoutDate?: moment.Moment
  title1?: string
  subTitle1?: string
  title2?: string
  subTitle2?: string
  useSingleDate?: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const DEFAULT_DATES_SUB_TITLE = 'Anytime'

export function DatesInputTrigger({
  onClick,
  checkinDate,
  checkoutDate,
  title1 = 'Check in',
  subTitle1 = DEFAULT_DATES_SUB_TITLE,
  title2 = 'Check out',
  subTitle2 = DEFAULT_DATES_SUB_TITLE,
  useSingleDate,
}: DatesProps) {
  return (
    <Container onClick={onClick}>
      <Item>
        <Caption variant="large" weight="bold">
          {title1}
        </Caption>
        <BodyText
          variant="medium"
          colour={checkinDate ? 'neutral-one' : 'neutral-three'}
        >
          {checkinDate ? checkinDate.format(DMY_CASUAL_FORMAT) : subTitle1}
        </BodyText>
      </Item>
      {!useSingleDate && (
        <Item>
          <Caption variant="large" weight="bold">
            {title2}
          </Caption>
          <BodyText
            variant="medium"
            colour={checkoutDate ? 'neutral-one' : 'neutral-three'}
          >
            {checkoutDate ? checkoutDate.format(DMY_CASUAL_FORMAT) : subTitle2}
          </BodyText>
        </Item>
      )}
    </Container>
  )
}
